module.exports = __webpack_public_path__ + "img/2021_10_damde_saga_fin_web.b85d5e65.png";